import { render, staticRenderFns } from "./EventInvoiceDetail.vue?vue&type=template&id=83177374"
import script from "./EventInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./EventInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./EventInvoiceDetail.vue?vue&type=style&index=0&id=83177374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports